// SSE 订阅 - 替代 Electron IPC 的 onHeigeEvent
// 使用 EventSource（浏览器原生），后端 push 'event: event' / 'event: recent'
import { SSE_CONFIG } from './api';

export interface HeigeStreamEvent {
  id: string;
  type: string;
  label: string;
  severity: 1 | 2 | 3 | 4 | 5;
  timestamp: number;
  feedId?: string;
  feedName?: string;
  externalUrl?: string;
  abstract?: string;
}

/**
 * 订阅黑哥们事件流
 * 返回 cleanup 函数
 */
export function subscribeHeigeStream(
  onEvent: (ev: HeigeStreamEvent) => void,
  onError?: (err: Event) => void,
): () => void {
  const url = SSE_CONFIG.subscribeUrl();
  if (!url.includes('token=')) {
    console.warn('[sse] no token, skip subscribe');
    return () => {};
  }

  const es = new EventSource(url);

  es.addEventListener('event', (e) => {
    try {
      const data = JSON.parse((e as MessageEvent).data) as HeigeStreamEvent;
      onEvent(data);
    } catch (err) {
      console.warn('[sse] parse event failed:', err);
    }
  });

  // 'recent' 是连接时发的历史回放，可选处理
  es.addEventListener('recent', (e) => {
    // 静默忽略，避免重复弹窗
    console.debug('[sse] recent replay:', (e as MessageEvent).data?.slice(0, 50));
  });

  es.onerror = (e) => {
    console.warn('[sse] connection error', e);
    onError?.(e);
    // EventSource 默认会自动重连；如要手动控制可在这里 es.close()
  };

  return () => es.close();
}